import React, { useState } from "react";
import './staff-modules.css';

const SAMPLE_PLANS = [
  {
    id: 1,
    subject: "Nursing Foundations",
    date: "2025-09-01",
    topic: "Introduction to Nursing",
    document: "",
    status: "Completed",
    notes: "Covered basics and scope."
  },
  {
    id: 2,
    subject: "Community Health",
    date: "2025-09-02",
    topic: "Health Indicators",
    document: "",
    status: "Pending",
    notes: ""
  }
];
const SAMPLE_SUBJECTS = ["Nursing Foundations", "Community Health", "Medical-Surgical Nursing"];

export default function LessonPlan() {
  const [plans, setPlans] = useState(SAMPLE_PLANS);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    subject: SAMPLE_SUBJECTS[0],
    date: "",
    topic: "",
    document: "",
    status: "Pending",
    notes: ""
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setForm({
      ...form,
      [name]: files ? files[0].name : value
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setPlans([
      { ...form, id: Date.now() },
      ...plans
    ]);
    setForm({
      subject: SAMPLE_SUBJECTS[0],
      date: "",
      topic: "",
      document: "",
      status: "Pending",
      notes: ""
    });
    setShowForm(false);
  };

  return (
    <div className="module-wrapper">
      <h2>Lesson Plan</h2>
      <p>
        Upload, organize, and review lesson plans for each subject and batch. Track syllabus coverage and add notes or supporting documents.
      </p>
      <div className="module-actions">
        <button className="primary-action" onClick={() => setShowForm(s => !s)}>
          {showForm ? "Cancel" : "Upload Lesson Plan"}
        </button>
      </div>
      {showForm && (
        <form className="lessonplan-form" onSubmit={handleFormSubmit}>
          <div className="form-row">
            <label>Subject:</label>
            <select name="subject" value={form.subject} onChange={handleInputChange} required>
              {SAMPLE_SUBJECTS.map((subj) => (
                <option key={subj}>{subj}</option>
              ))}
            </select>
          </div>
          <div className="form-row">
            <label>Date:</label>
            <input name="date" type="date" value={form.date} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label>Topic:</label>
            <input name="topic" value={form.topic} onChange={handleInputChange} required />
          </div>
          <div className="form-row">
            <label>Document (optional):</label>
            <input name="document" type="file" onChange={handleInputChange} />
          </div>
          <div className="form-row">
            <label>Status:</label>
            <select name="status" value={form.status} onChange={handleInputChange}>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
          <div className="form-row">
            <label>Notes:</label>
            <textarea name="notes" value={form.notes} onChange={handleInputChange} rows={2} />
          </div>
          <button type="submit" className="primary-action">Save Lesson Plan</button>
        </form>
      )}
      <div className="lessonplan-list">
        <h3>Lesson Plans</h3>
        <table className="lessonplan-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Subject</th>
              <th>Topic</th>
              <th>Status</th>
              <th>Notes</th>
              <th>Document</th>
            </tr>
          </thead>
          <tbody>
            {plans.map(plan => (
              <tr key={plan.id}>
                <td>{plan.date}</td>
                <td>{plan.subject}</td>
                <td>{plan.topic}</td>
                <td>{plan.status}</td>
                <td>{plan.notes}</td>
                <td>{plan.document ? <a href={`/${plan.document}`} download>{plan.document}</a> : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}